import React from 'react';
import Title from './Components/Title';
import styles from './styles.module.scss';
import icThg from 'assets/img/thetan_gem_V2.png';
import icTicket from 'assets/svg/ic_ticket.svg';
import bgGem from 'assets/img/bg_gem.png';
import classNames from 'classnames';
import { formatCurrency } from '@wolffun/system-currency';

const Summary = ({
  className,
  summary
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.leftSection
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.background,
    src: bgGem
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.blurBottom
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.blurRight
  }), /*#__PURE__*/React.createElement(Title, {
    className: styles.title,
    title: "Total Earn"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.cardDetail
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.iconBackground
  }, /*#__PURE__*/React.createElement("img", {
    src: icThg
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.textWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.subTitle
  }, "Total Claimed THG Rewards"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, summary ? formatCurrency(summary.thgClaimed, {
    withCurrency: true,
    trimWholeFraction: true
  }) : '--'))), /*#__PURE__*/React.createElement("div", {
    className: styles.cardDetail
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.iconBackground, styles.yellow)
  }, /*#__PURE__*/React.createElement("img", {
    src: icTicket
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.textWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.subTitle
  }, "Available Private Tickets"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, summary ? formatCurrency(summary.availableTicket, {
    withCurrency: false,
    trimWholeFraction: true
  }) : '--')))), /*#__PURE__*/React.createElement("div", {
    className: styles.rightSection
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.card
  }, /*#__PURE__*/React.createElement(Title, {
    className: styles.title,
    title: "My Staked"
  }), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.value, styles.bigSize)
  }, summary ? formatCurrency(summary.totalStaked, {
    withCurrency: true,
    precision: 0
  }) : '--')), /*#__PURE__*/React.createElement("div", {
    className: styles.cardWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.card, styles.cardVertical)
  }, /*#__PURE__*/React.createElement(Title, {
    className: styles.title,
    title: "Pending THG Rewards"
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, summary ? formatCurrency(summary.pendingTHG, {
    withCurrency: true,
    trimWholeFraction: true
  }) : '--')), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.card, styles.cardVertical)
  }, /*#__PURE__*/React.createElement(Title, {
    className: styles.title,
    title: "Pending Tickets"
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, summary ? formatCurrency(summary.pendingTicket, {
    withCurrency: false,
    trimWholeFraction: true
  }) : '--')))));
};

export default Summary;